import React from 'react';
import INDUSTRIES from '../data/industries';

/* ====================================================================
 * <IndustriesServed /> — bridge between scientific practice areas
 * and the industry categories they serve. Editorial 6-block grid.
 * ==================================================================== */

const SLATE = '#0B1426';
const CORAL = '#FF4E6A';
const MUTED = '#5B6577';
const INK = '#1F2937';

export default function IndustriesServed() {
  return (
    <section
      id="industries"
      className="border-t"
      style={{ borderColor: '#E3D9C0', backgroundColor: '#FBF7EE' }}
      data-testid="tagc-industries"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-24">
        {/* Header */}
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-4">
            <p
              className="text-[11px] font-mono uppercase tracking-[0.3em] mb-4"
              style={{ color: CORAL }}
              data-testid="industries-eyebrow"
            >
              03 &mdash; Industries we serve
            </p>
            <h2 className="font-serif text-4xl lg:text-5xl leading-[1.05]" style={{ color: SLATE }}>
              Regulated categories, one scientific standard.
            </h2>
          </div>
          <div className="lg:col-span-7 lg:col-start-6 lg:pt-3">
            <p className="text-base lg:text-lg leading-relaxed" style={{ color: MUTED }}>
              Aᴳ engages across the regulated categories where exposure-based safety
              assessment, defensible documentation, and independent scientific opinion
              carry commercial and regulatory consequence. The same scientific methodology
              scales across every category we serve.
            </p>
          </div>
        </div>

        {/* Industry grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
          {INDUSTRIES.map((group) => (
            <article
              key={group.id}
              data-testid={`industry-${group.id}`}
              className="border-t pt-6"
              style={{ borderColor: '#D6CDB8' }}
            >
              <h3
                className="font-serif text-xl lg:text-[22px] mb-4 leading-tight"
                style={{ color: SLATE }}
              >
                {group.title}
              </h3>
              <ul className="space-y-2 text-[13.5px]" style={{ color: INK }}>
                {group.items.map((item) => (
                  <li key={item} className="flex items-start gap-2">
                    <span
                      className="mt-2 w-1 h-1 rounded-full shrink-0"
                      style={{ backgroundColor: CORAL }}
                    />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
